import { jsxs as c, jsx as a } from "react/jsx-runtime";
import { forwardRef as b } from "react";
import { classNames as u } from "../../../Utils/classNames.js";
const m = b((o, s) => {
  const { className: t, errorMessage: r, hasError: l, testId: d, ...e } = o;
  return /* @__PURE__ */ c("div", { "data-testid": d, className: "w-full flex flex-col space-y-2", children: [
    /* @__PURE__ */ a(
      "input",
      {
        className: u(
          t,
          "bg-gray-50 border text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
          r || l ? "border-red-500" : "border-gray-300",
          e.disabled ? "bg-slate-100 cursor-not-allowed text-gray-900/50" : "bg-white text-gray-900"
        ),
        ...e,
        ref: s
      }
    ),
    r ? /* @__PURE__ */ a("p", { className: "text-red-500", children: r }) : null
  ] });
});
export {
  m as TextInput
};
//# sourceMappingURL=TextInput.js.map
